import { BiteLogFlashEvent } from './bite_log_flash_event.js';

export function name(event: BiteLogFlashEvent): string {
  switch (event) {
    case BiteLogFlashEvent.SessionTokenExpired:
      return 'session-token-expired';
    case BiteLogFlashEvent.SessionTokenInvalid:
      return 'session-token-invalid';
  }
}
